import {
  GET_USER,
  GET_USERS,
  USER_ERROR,
  UPDATE_USER,
  CLEAR_USER
  // USER_DELETED
} from '../actions/types';

const initialState = {
  user: null,
  users: [],
  loading: true,
  error: {}
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_USER:
    case UPDATE_USER:
      return {
        ...state,
        user: payload,
        loading: false
      };
    case GET_USERS:
      return {
        ...state,
        users: payload,
        loading: false
      };
    case USER_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
        user: null,
        users: []
      };
    case CLEAR_USER:
      return {
        ...state,
        user: null,
        users: [],
        loading: false
      };
    default:
      return state;
  }
}
